export const SAVE = 'tripDelayStep.SAVE';
export const VALUE_CHANGED = 'tripDelayStep.VALUE_CHANGED';
export const LOAD = 'tripDelayStep.VALUE_LOAD';
export const NEXT = 'tripDelayStep.NEXT';
export const RESET = 'tripDelayStep.RESET';
export const RESET_DAMAGED_LOST_EXPENSE = 'tripDelayStep.RESET_DAMAGED_LOST_EXPENSE';
export const RESET_DELAYED_LUGGAGE_EXPENSE = 'tripDelayStep.RESET_DELAYED_LUGGAGE_EXPENSE';
export const RESET_COMPENSATION = 'tripDelayStep.RESET_COMPENSATION';
//-------------------------------------------------------
export const RESET_TRIP_CANCELLATION_STATE = 'tripDelayStep.RESET_TRIP_CANCELLATION_STATE';
export const RESET_TRAVEL_INTERRUPTION_STATE = 'tripDelayStep.RESET_TRAVEL_INTERRUPTION_STATE';
export const RESET_TRAVEL_DELAY_STATE = 'tripDelayStep.RESET_TRAVEL_DELAY_STATE';

export const REPORT_TO = {
  POLICE: '1',
  HOTEL_MANAGEMENT: '2',
  CRUISE_SHIP: '3',
  AIRLINE: '4',
  TOUR_GUIDE: '5',
  OTHER: '6',
  NOT_REPORT: '18',
};

export const CLAIMING_FOR = {
  PASSPORT_CREDIT_CARD: 'claimForPassportCreditCard',
  THEFT_OF_CASH: 'claimForTheftOfCash',
  LUGGAGE_AND_PERSONAL_EFFECTS: 'claimForLuggageAndPersonalEffect',
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.NationWide.TripDelayStep/constants.js